import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/_org/agents/$agentId/')({
  beforeLoad: async ({ params }) => {
    throw redirect({
      to: '/agents/$agentId/inbox',
      params: { agentId: params.agentId },
    });
  },
});
